import olLayerGroup from './../../node_modules/ol/layer/Group.js';

class LayerGroup extends olLayerGroup {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

export default LayerGroup;